<section class="main-section p-md-3">

    <div class="container row gx-0 gy-0 p-2 w-100">

        <div *ngFor="let item of lst_Menu" class="col-lg-4 col-md-6 col-12 p-2">

            <div class="menu-item p-2" [routerLink]="item.routerLink" (click)="item?.iAction ? showAction(item?.iAction) : ''">

                <div class="img-container">

                    <img [src]="item.strImage" [alt]="item.strTitle">

                </div>

                <div class="title-container">

                    <p class="fw-bold"> {{ item.strTitle }} </p>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- مدال افزودن سرویس -->

<div class="modal fade" id="newReq_Modal">    

    <div class="modal-dialog modal-lg modal-fullscreen-sm-down">

        <div class="modal-content">

            <div class="modal-header">

                <h3 class="modal-title mb-0"> ثبت درخواست سفر </h3>

                <button type="button" class="btn" data-bs-dismiss="modal">

                    <mat-icon class="d-flex mat-18">close</mat-icon>

                </button>
                

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_TripSAD" class="container-fluid row gx-2 gy-md-0 gy-2 px-2">

                    <!-- موبایل متقاضی  -->

                    <div class="position-relative col-12 col-md-4">
                
                        <label> موبایل متقاضی  * </label>
            
                        <input class="form-control p-2 text-center"
                        
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            maxlength="11"

                            formControlName="strMobile">

                        <ng-container *ngIf="bEditMode != 'showMode'">

                            <button class="btn btn-info rounded" (click)="search_ByMobile()">

                                <i class="fa fa-search" aria-hidden="true"></i>
                                
                            </button>

                        </ng-container>
            
                    </div>

                    <!-- نام متقاضی  -->

                    <div class="position-relative col-12 col-md-4">
            
                        <label > نام متقاضی  </label>
            
                        <input class="form-control p-2 text-center" formControlName="strName">
            
                    </div>

                    <!-- نام خانوادگی متقاضی  -->

                    <div class="position-relative col-12 col-md-4">
            
                        <label> نام خانوادگی متقاضی  * </label>
            
                        <input class="form-control p-2 text-center" formControlName="strFamily">
            
                    </div>

                    <!-- نوع خودرو -->

                    <div class="col-12 col-md-4 position-relative">

                        <div class="w-100" *ngIf="list_MobileType.length">

                            <label> نوع خودرو * </label>

                            <custom-filter 

                                [strValue]="returnStrValue('tiMobileType',mdl_TripSAD.get('tiMobileType')?.value,list_MobileType,'strComment')"

                                [strComment]="'strComment'"

                                [stylesArray]="['padding-top: 10px','text-align: center']"

                                [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_MobileType"

                                [lst_SearchKey]="['strComment']" [isDisabled]="false"

                                (hideOptions)="mdl_TripSAD.get('tiMobileType')?.setValue($event.tiMobileType)">

                            </custom-filter>

                        </div>

                    </div>

                    <!-- پلاک خودرو -->

                    <div class="col-12 col-md-4 position-relative">

                        <div class="w-100">

                            <label> پلاک خودرو *</label>

                            <div class="plate-container d-flex">

                                <input class="form-control text-center w-25" 
                                
                                    (input)="filterNumericInput($event)" inputmode="numeric"
                                
                                    maxlength="2" placeholder="- -" 
                                    
                                    formControlName="strVehicleNo_4">

                                <input class="form-control text-center w-25" 
                                
                                    (input)="filterNumericInput($event)" inputmode="numeric"
                                
                                    maxlength="3" placeholder="- - -" 
                                    
                                    formControlName="strVehicleNo_3">

                                <input class="form-control text-center w-25" 

                                    oninput="this.value=this.value.replace(/[^ء-ی]/g, '')"
                                
                                    maxlength="1" placeholder="-" 
                                    
                                    formControlName="strVehicleNo_2">

                                <input class="form-control text-center w-25" 
                                
                                    (input)="filterNumericInput($event)" inputmode="numeric"
                                
                                    maxlength="2" placeholder="- -" 
                                    
                                    formControlName="strVehicleNo_1">

                            </div>

                        </div>

                    </div>

                    <!-- علت درخواست امداد -->

                    <div class="col-12 col-md-4 position-relative">

                        <div class="w-100" *ngIf="list_Reason.length">

                            <label> علت درخواست * </label>

                            <custom-filter 

                                [strValue]="returnStrValue('tiReason4Request',mdl_TripSAD.get('tiReason4Request')?.value,list_Reason,'strComment')"

                                [strComment]="'strComment'"

                                [stylesArray]="['padding-top: 10px','text-align: center']"

                                [str_Placeholder]="' جستجو کنید ...'" 
                                
                                [lst_Main]="list_Reason"

                                [lst_SearchKey]="['strComment']" 
                                
                                [isDisabled]="false"

                                (hideOptions)="mdl_TripSAD.get('tiReason4Request')?.setValue($event.tiReason4Request)">

                            </custom-filter>

                        </div>

                    </div>

                    <!-- نوع درخواست امداد  -->

                    <div class="col-12 col-md-4 position-relative">

                        <div class="w-100" *ngIf="list_ReliefType.length">

                            <label> نوع درخواست * </label>

                            <custom-filter 

                                [strValue]="returnStrValue('tiReliefRequestType',mdl_TripSAD.get('tiReliefRequestType')?.value,list_ReliefType,'strComment')"

                                [strComment]="'strComment'"

                                [stylesArray]="['padding-top: 10px','text-align: center']"

                                [str_Placeholder]="' جستجو کنید ...'" 
                                
                                [lst_Main]="list_ReliefType"

                                [lst_SearchKey]="['strComment']" 
                                
                                [isDisabled]="false"

                                (hideOptions)="mdl_TripSAD.get('tiReliefRequestType')?.setValue($event.tiReliefRequestType)">

                            </custom-filter>

                        </div>

                    </div>

                    <!-- دلیل توقف -->

                    <div class="col-12 col-md-4 position-relative">

                        <div class="w-100">

                            <label> دلیل توقف </label>

                            <input class="form-control w-100" formControlName="strReasonStopping" placeholder="دلیل توقف خود را مشخص کنید...">

                        </div>

                    </div>

                    <!-- نوع جرثقیل  -->

                    <div class="col-12 col-md-4 position-relative">

                        <div class="w-100" *ngIf="list_MobileGroup.length">

                            <label> نوع جرثقیل * </label>

                            <custom-filter 

                                [strValue]="returnStrValue('tiMobileGroup',mdl_TripSAD.get('tiMobileGroup')?.value,list_MobileGroup,'strComment')"

                                [strComment]="'strComment'"

                                [stylesArray]="['padding-top: 10px','text-align: center']"

                                [str_Placeholder]="' جستجو کنید ...'" 
                                
                                [lst_Main]="list_MobileGroup"

                                [lst_SearchKey]="['strComment']" 
                                
                                [isDisabled]="false"

                                (hideOptions)="mdl_TripSAD.get('tiMobileGroup')?.setValue($event.tiMobileGroup)">

                            </custom-filter>

                        </div>

                    </div>

                    <!-- شهر مبداء -->

                    <div class="col-12 position-relative">

                        <div class="w-100" *ngIf="list_City.length && showFilter">

                            <label> شهر مبداء * </label>

                            <custom-filter 

                                [strValue]="returnStrValue('strCity',mdl_TripSAD.get('strSCity')?.value,list_City,'strCityName')"

                                [strComment]="'strCityName'"

                                [stylesArray]="['padding-top: 10px','text-align: center']"

                                [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_City"

                                [lst_SearchKey]="['strCityName']" [isDisabled]="false"

                                (hideOptions)="setValue_Filter($event,'strSCity')">

                            </custom-filter>

                        </div>

                    </div>

                    <!-- آدرس مبداء -->

                    <div class="position-relative col-12">

                        <label class="text-muted"> آدرس مبداء * </label>

                        <input class="form-control p-2 input-start" placeholder="آدرس دقیق خود را وارد کنید ..." formControlName="strSAddress">

                        <button class="btn btn-warning rounded" (click)="show_Map('strSAddress')">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                        </button>

                    </div>

                    <!-- مدال نقشه -->
                    
                    <app-custom-map *ngIf="showCustom_Map"
                    
                        [strValue]="mdl_Map.get('strAddress')?.value"
            
                        [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"

                        [isOpenModal]="true"

                        (mdl_Submit)="submitMap($event)">
    
                    </app-custom-map>

                    <!-- تاریخ -->

                    <div class="col-12 col-md-4 position-relative">

                        <label class="text-muted"> تاریخ * </label>

                        <ng-persian-datepicker [uiTheme]="'gray'" 
                        
                            [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input style="background-color: #ffff;" class="form-control text-start" formControlName="strDate" readonly />

                        </ng-persian-datepicker>

                    </div>

                    <!-- ساعت -->

                    <div class="col-12 col-md-4 position-relative">

                        <label class="text-muted"> ساعت * </label>

                        <input formControlName="strTime" required class="form-control text-center" [format]="24" [ngxTimepicker]="picker">

                        <ngx-material-timepicker #picker [cancelBtnTmpl]="cancelBtn"

                            [confirmBtnTmpl]="confirmBtn">

                        </ngx-material-timepicker>

                        <ng-template #cancelBtn>

                            <button class="Btn_timePicker " style="margin-right: 10px;background-color: #ff0000;">لغو</button>

                        </ng-template>

                        <ng-template #confirmBtn>

                            <button class="Btn_timePicker " style="background-color: #009620;">تایید</button>

                        </ng-template>

                    </div>

                    <!-- شهر مقصد -->

                    <div class="col-12 position-relative">

                        <div class="w-100" *ngIf="list_City.length && showFilter">

                            <label>شهر مقصد</label>

                            <custom-filter 

                                [strValue]="returnStrValue('strCity',mdl_TripSAD.get('strDCity')?.value,list_City,'strCityName')"

                                [strComment]="'strCityName'"

                                [stylesArray]="['padding-top: 10px','text-align: center']"

                                [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_City"

                                [lst_SearchKey]="['strCityName']" [isDisabled]="false"

                                (hideOptions)="setValue_Filter($event,'strDCity')">

                            </custom-filter>

                        </div>

                    </div>

                    <!-- آدرس مقصد -->

                    <div class="position-relative col-12">

                        <label class="text-muted"> آدرس مقصد </label>

                        <input class="form-control p-2 input-start" placeholder="آدرس دقیق خود را وارد کنید ..." formControlName="strDAddress">

                        <button class="btn btn-warning rounded" (click)="show_Map('strDAddress')">

                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                        </button>

                    </div>

                    <!-- طرح ترافیک -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">

                        <input class="form-check-input m-0" type="checkbox" id="bTraffic" formControlName="bTraffic">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bTraffic"> طرح ترافیک </label>
                    
                    </div>

                    <!-- طرح آلودگی -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">

                        <input class="form-check-input m-0" type="checkbox" id="bEvenOdd" formControlName="bEvenOdd">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bEvenOdd"> طرح آلودگی </label>
                    
                    </div>

                    <!-- شرایط آب وهوایی ویژه -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">

                        <input class="form-check-input m-0" type="checkbox" id="bBadWeather" formControlName="bBadWeather">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bBadWeather"> شرایط آب وهوایی ویژه </label>
                    
                    </div>

                    <!-- منطقه کوهستانی -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">

                        <input class="form-check-input m-0" type="checkbox" id="bMountainous" formControlName="bMountainous">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bMountainous"> منطقه کوهستانی </label>
                    
                    </div>

                    <!-- توضیحات -->

                    <div class="col-12 position-relative mt-2">

                        <div class="w-100">

                            <textarea class="form-control w-100" formControlName="strComment" 
                            
                                placeholder="توضیحات خود را وارد کنید ...">
                            
                            </textarea>

                        </div>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <!-- ثبت -->

                <button class="btn btn-success" (click)="submit_Request()"> 
                    
                    ثبت درخواست 
                
                </button>

                <!-- بستن -->

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- مدال تغییر رمز عبور -->

<div class="modal fade" id="PW_Modal">    

    <div class="modal-dialog modal-lg modal-fullscreen-sm-down">

        <div class="modal-content">

            <div class="modal-header">

                <h3 class="modal-title mb-0"> تغییر رمز عبور </h3>

                <button type="button" class="btn" data-bs-dismiss="modal">

                    <mat-icon class="d-flex mat-18">close</mat-icon>

                </button>
                

            </div>

            <div class="modal-body p-2">

                <div [formGroup]="mdl_PW" class="container-fluid row gx-2 gy-md-0 gy-2 p-2">

                    <!--  رمز عبور فعلی -->

                    <div class="col-12 d-flex justify-content-center align-items-center p-2">

                      <div class="input-container position-relative w-50 p-2">

                        <label class="mb-2 text-muted"> * رمز عبور فعلی </label>

                        <input type="password" formControlName="currentPassword" autocomplete="new-password" class="form-control p-2 text-center">

                      </div>

                    </div>
                  
                    <!-- رمز عبور جدید -->

                    <div class="col-12 d-flex justify-content-center align-items-center p-2">

                      <div class="input-container position-relative w-50 p-2">

                        <label class="mb-2 text-muted"> * رمز عبور جدید </label>

                        <input type="password" formControlName="newPassword" (input)="checkPasswordStrength()" class="form-control p-2 text-center">

                        <div class="strength-meter mt-2">

                          <div class="strength-bar" [ngClass]="passwordStrength"></div>

                        </div>

                        <small class="text-muted">{{ passwordStrengthMessage }}</small>

                      </div>

                    </div>
                  
                    <!-- تکرار رمز عبور جدید -->

                    <div class="col-12 d-flex justify-content-center align-items-center p-2">

                      <div class="input-container position-relative w-50 p-2">

                        <label class="mb-2 text-muted"> * تکرار رمز عبور جدید </label>

                        <input type="password" formControlName="confirmPassword" class="form-control p-2 text-center">

                      </div>

                    </div>

                    <!-- راهنمای رمز عبور قوی -->

                    <div class="d-none hints col-12 d-flex justify-content-center align-items-center p-2">

                        <ul class="input-container position-relative w-50 p-2">

                            <li [class.text-success]="hasUpperCase">شامل حداقل یک حرف بزرگ</li>

                            <li [class.text-success]="hasLowerCase">شامل حداقل یک حرف کوچک</li>

                            <li [class.text-success]="hasNumbers">شامل حداقل یک عدد</li>

                            <li [class.text-success]="hasSpecialChars">{{ 'شامل حداقل یک کاراکتر خاص (!@#$%^&*)' }}</li>

                            <li [class.text-success]="isLongEnough"> {{ 'حداقل 8 کاراکتر' | faNum }} </li>

                        </ul>
                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <!-- تایید -->

                <button class="btn btn-success px-3" (click)="submit_Password()">

                    &nbsp; تایید &nbsp;

                </button>

                <!-- بستن -->

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>